// @ts-nocheck
import axios from "axios";
import { store } from "../store/store";
import { alertDialogAciton } from "../store/actions/auth";
import { apiRequest } from "./apiService";
import { describePdfRequestError } from "../utils/methods/shareablePrintGate";

const axiosInstance = axios.create({
  baseURL:
    import.meta.env.VITE_PDF_URL || "https://dev-document.showphaze.com/api",
  responseType: "blob",
});

export const pdfApiRequest = async ({
  method = "GET",
  url,
  data,
  params,
  version,
  fileName,
  isToken = false,
  // `returnBlob: true` → `{ blob, fileName }` instead of a download. The in-app
  // PDF preview (history modals, `usePdfPreview`) relies on it.
  returnBlob = false,
}) => {
  try {
    const { auth } = store.getState();
    const token = auth?.userToken;

    // O baseURL enviado ao pdf-service é a MESMA base de API que o FE usa
    // (VITE_API_URL como está): local não tem prefixo /api; deployado o backend
    // serve sob /api (API_PREFIX=api). Passar como está funciona nos dois —
    // NÃO remover o /api (removia e quebrava todo PDF no ambiente deployado).
    const beUrl = (import.meta.env.VITE_API_URL || "").replace(/\/$/, "");

    const response = await axiosInstance({
      method,
      url,
      data: {
        ...data,
        TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        baseURL: beUrl,
        // ALWAYS include the token — the pdf-service needs to forward it to
        // the new BE via the Authorization header (the NestJS *ForPdf endpoints
        // require auth + role). It used to be conditional via `isToken: true`,
        // but no caller ever passed it, so the pdf-service hit the BE as
        // anonymous → 401 → the PDF came back empty. Keeping `token` always is
        // safe: the pdf-service does not log, and the body already carries other
        // sensitive values (baseURL).
        ...(token ? { token } : {}),
      },
      params,
    });

    if (response?.status !== 200) {
      throw new Error(response?.data?.message);
    }

    // Create a blob from the response
    const blob = new Blob([response.data], { type: "application/pdf" });

    // If returnBlob is true, return the blob without downloading
    if (returnBlob) {
      return {
        blob,
        fileName: fileName ? `${fileName}.pdf` : "downloaded_file.pdf",
      };
    }

    // Otherwise, download as before (existing behavior)
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName ? `${fileName}.pdf` : "downloaded_file.pdf";
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

    return null; // Return null for download case
  } catch (error) {
    // Because of `responseType: "blob"`, axios puts the pdf-service error body
    // into `error.response.data` as a Blob — which is where the REAL message
    // lives (e.g. "Missing or invalid estimateId"). Without reading the blob we
    // would only be left with the generic "Request failed with status code 400".
    let message = error?.message;
    const errBody = error?.response?.data;
    if (errBody instanceof Blob) {
      try {
        const text = (await errBody.text())?.trim();
        if (text) message = text;
      } catch {
        /* keep the generic message */
      }
    } else if (typeof errBody === "string" && errBody) {
      message = errBody;
    }
    // A 401 here is always the backend refusing the forwarded token (signed
    // out or expired session): say so instead of the raw "Token is missing".
    message = describePdfRequestError({
      status: error?.response?.status,
      fallback: message,
    });
    store.dispatch(
      alertDialogAciton({
        open: true,
        title: "Error",
        message,
      }),
    );
    return null;
  }
};